import React from 'react';
import classnames from 'classnames';


interface IProps {
    firstName: string;
    lastName: string;
    markedName: string | JSX.Element;
}

export const AttendeePresentation = ( props: IProps ) => {
    const { firstName, lastName, markedName } = props;

    return (
        <div className='attendees-list-item__radio-button-content'>
            <div
                className={classnames('attendees-list-item__label', 'overflow-ellipsis')}
                title={`${firstName} ${lastName}`}
            >
                {markedName ?? `${firstName} ${lastName}`}
            </div>
        </div>
    );
};

